// extracted by mini-css-extract-plugin
module.exports = {"bsFormControl":"bsFormControl_bsFormControl__2hIhe","inline":"bsFormControl_inline__3og1w"};